module.exports = __webpack_public_path__ + "img/sticker-flower2.6a68b9ac.png";